import { ElMessage } from "element-plus";
import * as request from "@/http/httpRequest";
import send from "./sendStatistics";

import useLinkUploadError from "@/helpers/useLinkUploadError";

const { saveLinkErrorInfo } = useLinkUploadError();

const videoDownload = {};

videoDownload.getVideoInfo = (url, videoSource, action, captchaType, captchaToken, temp) => {
    return new Promise((resolve) => {
        request
            .queryYtDlpVideoInfo(url, videoSource, captchaToken, captchaType, temp, action)
            .then((res) => {
                resolve(res);
            })
            .catch(() => {
                resolve(undefined);
            });
    });
};
/**
 * 获取指定的query参数x
 * @param key 参数的key
 * @param url 获取参数的地址
 * @returns
 */
videoDownload.getQueryParamsByKey = function (key, url) {
    const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
    const r = url.substr(url.indexOf("?") + 1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
};

/**
 * 判断目标链接是否无效，若对应的链接为空则直接判断为无效；若存在链接，判断下载地址中的过期时间expire，若当前未超过过期时间则未失效（youtube的视频下载，音频下载，文本下载均有对应参数；tiktok部分地址存在改参数；x的链接目前未确定相关过期参数）
 * @param url 目标url
 * @param bufferTime 缓冲时间，默认1小时
 */
videoDownload.isInvalidFileUrl = (url, bufferTime = 60 * 60) => {
    if (!url) {
        // 链接不存在，按无效处理
        return true;
    }
    // 尝试取出下载地址中的过期时间，判断下载链接是否无效
    const expire = videoDownload.getQueryParamsByKey("expire", url);
    if (expire) {
        // 时间戳单位转换为秒。
        const currentTime = parseInt(String(new Date().getTime() / 1000));
        // 判断当前时间+缓存时间是否大于过期时间
        return currentTime + bufferTime > expire;
    } else {
        // 若取不到过期时间，则按已过期处理,下载链接无效
        return false;
    }
};

// 重新请求数据而后下载
videoDownload.downloadMediaByNewInfo = async (info, fileType) => {
    const { downloadType, sourceVideoUrl, videoSource, action, selectedOptionIndex, captchaType, captchaToken, temp } =
        info;
    try {
        // 重新请求的媒体信息
        const axiosResponse = await videoDownload.getVideoInfo(
            sourceVideoUrl,
            videoSource,
            action,
            captchaType,
            captchaToken,
            temp
        );
        if (axiosResponse.response?.status === 429) {
            ElMessage({
                message: "You\u0027ve exceed the download limit. Please try again later.",
                type: "error",
            });
            send.collect(send.vmw_downloadVideoError, { fromButton: fileType });
            saveLinkErrorInfo(sourceVideoUrl, "You\u0027ve exceed the download limit. Please try again later.", true);
            return;
        }
        if (axiosResponse.code === -6001 || axiosResponse.code === -6000) {
            return axiosResponse.code;
        }
        const videoInfo = axiosResponse.data;
        let baseDownloadUrl = undefined;
        // 若选择过的分辨率，且对应的分辨率地址还存在，则重新取下载地址时要根据索引选择对应的分辨率
        if (selectedOptionIndex !== -1 && videoInfo["formats"][selectedOptionIndex]?.url?.length !== 0) {
            baseDownloadUrl = videoInfo["formats"][selectedOptionIndex].url;
        } else {
            // 基于当前类型获取新的下载地址
            baseDownloadUrl = downloadType === "video" ? videoInfo?.downloadUrl : videoInfo?.audioDownloadUrl;
        }
        if (baseDownloadUrl) {
            // 生成下载链接
            const newDownloadUrl = baseDownloadUrl + "&title=" + encodeURIComponent(videoInfo.videoName);
            window.open(newDownloadUrl, "_blank");
        } else {
            // 下载链接不存在给与提示
            ElMessage({
                type: "warning",
                message:
                    downloadType === "video"
                        ? "The video is not ready for download. We recommend waiting for a couple of hours and try again."
                        : "The audio is not ready for download. We recommend waiting for a couple of hours and try again.",
            });
            send.collect(send.vmw_downloadVideoError, { fromButton: fileType });
        }
    } catch (e) {
        ElMessage({
            type: "warning",
            message: "Something went wrong, please try again",
        });
        send.collect(send.vmw_downloadVideoError, { fromButton: fileType });
    }
};

/**
 * 下载音视频按钮的点击回调
 * @param downloadUrl 下载地址，可能为空
 * @param downloadType 下载类型：video-视频； audio-音频
 * @param sourceVideoUrl 视频的原始地址
 * @param videoSource 音视频来源
 * @param action 请求的action类型
 * @param selectedOptionIndex 选中的格式索引，默认为-1, 表示未选择分辨率;若不等于-1，则重新取下载地址时要根据索引选择对应的分辨率
 */
videoDownload.downloadMediaByUrl = async (
    downloadUrl,
    downloadType,
    sourceVideoUrl,
    videoSource,
    action,
    selectedOptionIndex = -1
) => {
    // 判断链接是否失效
    const invalidLink = videoDownload.isInvalidFileUrl(downloadUrl);
    if (!invalidLink) {
        // 可用
        window.open(downloadUrl, "_blank");
    } else {
        // 不可用（过期或地址不存在）,重新请求
        return { downloadType, sourceVideoUrl, videoSource, action, selectedOptionIndex };
    }
};

export default videoDownload;
